/**
 * Client-side logging utility for browser/React applications
 */
// Global log level state
let currentLogLevel = 'off';
export const setLogLevel = (level) => {
    const validLevels = ['off', 'error', 'warn', 'debug'];
    currentLogLevel = validLevels.includes(level) ? level : 'off';
};
/**
 * Check if a log level should be output
 * Level hierarchy: debug > warn > error > off
 */
const shouldLog = (level) => {
    const effectiveLevel = currentLogLevel;
    if (effectiveLevel === 'off')
        return false;
    if (effectiveLevel === 'debug')
        return true;
    if (effectiveLevel === 'warn')
        return level === 'warn' || level === 'error';
    if (effectiveLevel === 'error')
        return level === 'error';
    return false;
};
export const logDebug = (context, message, ...args) => {
    if (shouldLog('debug')) {
        console.log(`[${context}] ${message}`, ...args);
    }
};
export const logWarn = (context, message, ...args) => {
    if (shouldLog('warn')) {
        console.warn(`[${context}] ${message}`, ...args);
    }
};
export const logError = (context, message, ...args) => {
    if (shouldLog('error')) {
        console.error(`[${context}] ${message}`, ...args);
    }
};
export const logCurrentConfig = () => {
    console.log(`Log level configuration: [${currentLogLevel}]`);
};
//# sourceMappingURL=logger.js.map